import viewSubtasksUrl from './viewSubtasks.html';

class ViewSubtasksCtrl {
  toggleSubtask(subtask) {
    this.onChange({ subtask });
  }
}

export default {
  templateUrl: viewSubtasksUrl,
  controller: ViewSubtasksCtrl,
  controllerAs: 'ctrl',
  bindings: {
    isTaskInstanceCompleted: '<',
    subtasks: '<',
    canInteract: '<',
    onChange: '&?',
  },
};
